export const MAP_ACCESS_TOKEN =
  "pk.eyJ1Ijoic2VlZGFtYXAiLCJhIjoiY2t4MjdmNWF6MTh6MjJvbnlmZnVjZGhocSJ9.302b3-yN28PeK2nnfpDb0g";

export const MODE = "PROD";
